/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { TextField, Autocomplete } from "@mui/material";

const groupOptions = [
    { value: "D1", label: "D1" },
    { value: "D2", label: "D2" },
    { value: "D3", label: "D3" },
    { value: "D4", label: "D4" },
    { value: "D5", label: "D5" },
];

const GroupSelectMUI = ({
    name,
    value,
    label,
    placeholder,
    disabled,
    required,
    showAllOption,
    getValue,
    setValue,
    onChange,
}) => {
    const [formattedOptions, setFormattedOptions] = useState([]);

    useEffect(() => {
        const fOptions = [...groupOptions];

        if (showAllOption) {
            fOptions.unshift({ value: "", label: "All" });
        }

        setFormattedOptions(fOptions);
    }, [showAllOption]);

    return (
        <Autocomplete
            fullWidth
            disabled={disabled}
            getOptionLabel={(option) =>
                option?.label ??
                formattedOptions.find((opt) => opt.value === value)?.label
            }
            isOptionEqualToValue={(o, v) => o.value === v}
            isRequired={required}
            options={formattedOptions}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    placeholder={placeholder}
                    size="small"
                    variant="outlined"
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            height: '38px',
                            fontSize: '14px',
                            '& fieldset': {
                                borderColor: '#dbdbdb',
                                borderWidth: '1px',
                            },
                            '&:hover fieldset': {
                                borderColor: '#b5b5b5',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#3273dc',
                                borderWidth: '1px',
                            },
                        },
                        '& .MuiInputBase-input': {
                            padding: '8px 12px',
                            height: 'unset',
                        },
                    }}
                />
            )}
            size="small"
            value={getValue(value)}
            onChange={(_, option) => {
                onChange(name, setValue(option?.value));
            }}
        />
    );
};

GroupSelectMUI.propTypes = {
    name: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string.isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    showAllOption: PropTypes.bool,
    getValue: PropTypes.func,
    setValue: PropTypes.func,
    onChange: PropTypes.func,
};

GroupSelectMUI.defaultProps = {
    name: "",
    placeholder: "",
    label: "",
    disabled: false,
    required: false,
    showAllOption: false,
    getValue: (x) => x,
    setValue: (x) => x,
    onChange: () => { },
};

export default GroupSelectMUI; 